import './components.css';

interface StatCardProps {
  label: string;
  value: number | string;
  tone?: 'default' | 'danger' | 'success';
}

export function StatCard({ label, value, tone = 'default' }: StatCardProps) {
  const color = tone === 'danger' ? 'var(--danger)' : tone === 'success' ? 'var(--success)' : 'var(--text)';

  return (
    <div className="stat-card">
      <span className="stat-card__value" style={{ color }}>
        {value}
      </span>
      <span className="stat-card__label">{label}</span>
    </div>
  );
}
